import { connect } from 'react-redux'
import {
  taskChecklistItemsLoad,
  taskChecklistItemsCreate,
  taskChecklistItemMove,
  taskChecklistItemsSave,
  taskChecklistItemsDelete
} from '../../store/taskChecklistItems'
import ChecklistPanel from './ChecklistPanel'

const mapStateToProps = (state, ownProps) => ({
  taskChecklistItems: state.taskChecklistItems[ownProps.task.id]
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadTaskChecklistItems: () => { dispatch(taskChecklistItemsLoad(ownProps.task.id)) },
  createTaskChecklistItem: () => { dispatch(taskChecklistItemsCreate(ownProps.task.id)) },
  deleteTaskChecklistItem: (checklistItemId) => { dispatch(taskChecklistItemsDelete(ownProps.task.id, checklistItemId)) },
  moveTaskChecklistItem: (checklistItemId, nextChecklistItemId) => {
    dispatch(taskChecklistItemMove(ownProps.task.id, checklistItemId, nextChecklistItemId))
  },
  saveTaskChecklistItem: (checklistItemId, name, checked) => {
    dispatch(taskChecklistItemsSave(ownProps.task.id, checklistItemId, name, checked))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistPanel)



// WEBPACK FOOTER //
// ./src/components/ChecklistPanel/index.js